module.exports = __webpack_public_path__ + "img/hyrum.0b705eb7.png";